/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionDto } from '../../models/subscription-dto';

export interface SubscribeControllerFindReserveSubscription$Params {
  centerId: string;
}

export function subscribeControllerFindReserveSubscription(http: HttpClient, rootUrl: string, params: SubscribeControllerFindReserveSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, subscribeControllerFindReserveSubscription.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionDto>;
    })
  );
}

subscribeControllerFindReserveSubscription.PATH = '/api/subscribe/reserve';
